// components/TabSlider.jsx
import React, { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

const DashboardTabs = ({
  title,
  tabs = [],
  data = {},
  renderCard,
  link = "#",
  bgClass = ""
}) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const sliderSettings = {
    dots: false,
    infinite: false,
    slidesToShow:4.9,
    slidesToScroll: 1,
    speed: 500,
    swipeToSlide: false,
    focusOnSelect: true,
    touchMove: true,
    touchThreshold: 15,
   responsive: [
    { breakpoint: 1920, settings: { slidesToShow: 3.9 } },
    { breakpoint: 1600, settings: { slidesToShow: 3.9 } },
    { breakpoint: 1400, settings: { slidesToShow: 3.2 } },
    { breakpoint: 1200, settings: { slidesToShow: 3.2 } },
    { breakpoint: 991,  settings: { slidesToShow: 2.3 } },
    { breakpoint: 767,  settings: { slidesToShow: 1.9 } },
    { breakpoint: 576,  settings: { slidesToShow: 1.6 } },
    { breakpoint: 400,  settings: { slidesToShow: 1.1 } },
    // { breakpoint: 390,  settings: { slidesToShow: 1.1 } },
  ],
  };

  const items = data[activeTab] || [];

  return (
    <div className={`tabBg ${bgClass}`}>

<div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">

  <h4 className="fw-bold mb-0 h4-title">{title}</h4>

  <div className="dashboradTab-btn">
    {tabs.map((tab) => (
      <button
        key={tab}
        className={`btn btn-sm ${
          activeTab === tab ? "custom-active-btn" : "btn-outline-primary"
        }`}
        onClick={() => setActiveTab(tab)}
      >
        {tab}
      </button>
    ))}
  </div>

  {link && (
    <Link
      to={link}
      className="fw-bold text-decoration-none showAll"
    >
      Show all
    </Link>
  )}

</div>



      <Slider {...sliderSettings}>
        {items.length > 0 ? (
          items.map((item, i) => <div key={i}>{renderCard(item)}</div>)
        ) : (
          <div className="p-3 text-center w-100">No data available.</div>
        )}
      </Slider>
    </div>
  );
};

export default  DashboardTabs;
